<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="9" viewBox="0 0 13 9" fill="none">
        <path d="M2.02344 6.92871L6.71828 1.6025L11.4131 6.92871" stroke="#3D9E98" stroke-width="2" stroke-linecap="square"/>
    </svg>
</template>